export const isRichContent = (content) => {
    return content ? 'nodes' in content : false;
};
//# sourceMappingURL=is-rich-content.js.map